import { Link } from "react-router-dom";

export default function ConnectTradingAccountInstructions() {
  return (
    <div className="mt-4 rounded-xl border border-gray-100 bg-gray-50 p-4 text-sm dark:border-white/10 dark:bg-navy-900/40">
      <h3 className="font-bold text-navy-700 dark:text-white">
        How to connect your trading account
      </h3>
      <ol className="mt-2 list-decimal space-y-1.5 pl-5 text-gray-700 dark:text-gray-300">
        <li>Add your account.</li>
        <li>
          Click <strong>Connect to the system</strong> and allow at least 1 minute
          to connect.
        </li>
        <li>
          If the status is <strong>Disconnected</strong>, click <strong>Refresh</strong>{" "}
          and wait at least 1 minute.
        </li>
        <li>
          If the status is <strong>Connected</strong> and your balance is shown,
          your account is connected.
        </li>
        <li>
          If you still cannot connect, contact{" "}
          <Link
            to="/client/support"
            className="font-semibold text-brand-500 hover:underline dark:text-brand-300"
          >
            support
          </Link>
          .
        </li>
      </ol>
    </div>
  );
}
